<template>
<div class="chapter">
<div class="inner_page">
<h1 class="parttitle">PART I</h1>
<h1 class="parttitle">SEVEN YEARS TO SEVEN FIGURES: IS IT REALLY POSSIBLE?</h1>
<p class="paraaftertitle">I’ve broken this book into three parts so you can use it efficiently. Here’s what you’ll find:</p>
<p class="para">In Part I, I make my case: that you can’t get rich quickly by following most of the advice you get from newspapers, television, booksellers, and the Internet. Such popular advice is all about passive investing. My experience (and the lessons I’ve learned from friends and colleagues who’ve made money quickly) suggests a different course of action.</p>
<p class="para">Part II presents eight inspiring stories–step-by-step accounts of the successes of eight people I know personally. Read them once for motivation. Read them a second time for specific strategies and techniques you can use to build your own wealth.</p>
<p class="para">If you’re a baby boomer nearing retirement–or someone younger who simply doesn’t want to wait 40 years to get rich—you’ll have a particular interest in Part III, which explains why the <em class="italic">Seven Years to Seven Figures</em> program is perfect for you.</p>
<p class="para">Get ready to begin your path to seven figures. . . .</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?570bd161